<template>
  <div
    id="LegalIndex"
    class="container pb-22 bg-white"
  >
    <Head>
      <Title>{{ $messages('legal.meta.title') }}</Title>
      <Meta name="description" hid="description" :content="$messages('legal.meta.description')" />
    </Head>

    <div class="legal-layout-content rendered-md mt-0 leading-normal">
      <h1
        class="mb-2 md:mb-0 text-display-11 md:text-biggest lg:text-display-20 index-title"
      >
        {{ pageTitle }}
      </h1>
    </div>

    <ul>
      <li v-for="(section, index) in termsList" :key="index" class="section">
        <h2>
          {{ section.title }}
        </h2>
        <ul>
          <li v-for="(item, itemIndex) in section.sublist" :key="itemIndex">
            <NuxtLink :to="item.route" :prefetch="false">
              {{ item.title }}
            </NuxtLink>
          </li>
        </ul>
      </li>
    </ul>
  </div>
</template>
<script setup>
const { $messages, $mRouter } = useNuxtApp()
definePageMeta({
  layout: 'legal',
  routeKey: 'legal_terms_of_use'
})
const locale = useLocale()
const termsList = ref([])
const datoHelperClient = useDatoHelper()
const response = await datoHelperClient.getRecordsList('legal_page')

const sectionsMap = {}

// quick fix for sorting, needs to be refactored to see if it can be set in Dato
const sectionOrder = {
  MAJORITY: 0,
  'BANKING AND CARD': 1,
  PARTNERS: 2,
  MISCELLANEOUS: 3

}

response.forEach((item) => {
  const { section, ...rest } = item.attributes

  // Step 3: Check if section already exists and append or create it
  if (!sectionsMap[section]) {
    sectionsMap[section] = [{
      title: rest.title[locale],
      route: $mRouter.getLocalRoute({ name: 'terms-of-use-slug', params: { slug: rest.slug[locale] } }),
      order: sectionOrder[section]
    }]
  } else {
    sectionsMap[section].push({
      title: rest.title[locale],
      route: $mRouter.getLocalRoute({ name: 'terms-of-use-slug', params: { slug: rest.slug[locale] } }),
      order: sectionOrder[section]
    })
  }
})

termsList.value = Object.entries(sectionsMap).map(([section, items]) => ({
  title: section,
  sublist: items
})).sort((a, b) => a.sublist[0].order - b.sublist[0].order)

const pageTitle = computed(() => {
  return $messages('page_labels.legal_terms_of_use')
})

</script>
